import type {IGemstone, IProduct, IProductVariant} from '../module/LiveAgent/types/Show'
import displayPrice from "./displayPrice";

const makeImages = (productId: string): { size80: string, size300: string, size800: string } => {
    return {
        size80: 'https://cdn.media.juwelo.de/small/'+productId+'.jpg',
        size300: 'https://cdn.media.juwelo.de/large/'+productId+'.jpg',
        size800: 'https://cdn.media.juwelo.de/huge/'+productId+'.jpg',
    }
}

const extractProductVariantAspects = (product: IProduct, variant: IProductVariant) => {
    if(variant.material) {
        if(!product.availableVariantAspects.material) {
            product.availableVariantAspects.material = []
        }
        let pos = product.availableVariantAspects.material.indexOf(variant.material)
        if(pos < 0 && variant.available) {
            product.availableVariantAspects.material.push(variant.material)
        }
    }
    if(variant.ringsize) {
        if(!product.availableVariantAspects.ringsize) {
            product.availableVariantAspects.ringsize = []
        }
        let pos = product.availableVariantAspects.ringsize.indexOf(variant.ringsize)
        if(pos < 0 && variant.available) {
            product.availableVariantAspects.ringsize.push(variant.ringsize)
        }
    }
}

const extractProductVariantAspectsAvailability = (product: IProduct) => {
    if(product.availableVariantAspects.ringsize) {
        let availableValues = []
        for(let v=0;v<product.variants.length;v++) {
            let variant = product.variants[v];
            if(variant.available && availableValues.indexOf(variant.ringsize) < 0) {
                availableValues.push(variant.ringsize)
            }
        }
        product.availableVariantAspects.ringsize = availableValues
    }

    if(product.availableVariantAspects.material) {
        let availableValues = []
        for(let v=0;v<product.variants.length;v++) {
            let variant = product.variants[v];
            if(variant.available && availableValues.indexOf(variant.material) < 0) {
                availableValues.push(variant.material)
            }
        }
        product.availableVariantAspects.material = availableValues
    }
}

const extractProducts = (productsData: Array<Object> = [], variantMap: Array<Object> = []): Array<IProduct> => {
    let products: Array<IProduct> = []

    const onlyIf = (onlyIf, useThis) => {
        if(!onlyIf) {
        return null
        }
        if(onlyIf == 'OTHER' || onlyIf == 'OT' || onlyIf == 'N/A') {
            return null
        }
        return useThis
    }
    
    for(let i=0;i<productsData.length;i++) {
    
        // product infos
    
        let productData = productsData[i]
        let product: IProduct = {
            productId: productData.productInfo.productId,
            available: false,
            type: productData.localisation.productDetails.type,
            name: productData.localisation.productDetails.productName,
            brand: onlyIf(productData.productInfo.brand, productData.localisation.productDetails.brand),
            material: onlyIf(productData.productInfo.material, productData.localisation.productDetails.materialFriendlyName || productData.localisation.productDetails.materialFamily),
            materialWeight: onlyIf(productData.productInfo.materialWeight, productData.localisation.productDetails.materialWeight),
            caratWeight: onlyIf(productData.productInfo.totalCaratWeight, productData.localisation.productDetails.totalCaratWeight),
            designType: onlyIf(productData.productInfo.designType, productData.localisation.productDetails.designType),
            dimensions: productData.localisation.productDetails.dimensions,
            gemStones: [],
            variants: [],
            availableVariantAspects: {},
            image: makeImages(productData.productInfo.productId)
        }
        
        // prices
        
        if(productData.productPrice) {
            product.salesPrice = {
                text: displayPrice(productData.productPrice.priceInMCU),
                cent: productData.productPrice.priceInMCU,
            }
            if(productData.productPrice.originalPriceInMCU) {
                product.oldPrice = {
                    text: displayPrice(productData.productPrice.originalPriceInMCU),
                    cent: productData.productPrice.originalPriceInMCU,
                }
            }
        }
    
        // gemstones
    
        for(let j=0;j<productData.localisation.gems.length;j++) {
            let gemInfo = productData.gems[j]
            let gemData = productData.localisation.gems[j]
            let gemStone: IGemstone = {
                position: gemData.position,
                name: gemData.name,
                numberOfStones: gemData.count || 1,
                color: onlyIf(gemInfo.colour, gemData.colour),
                caratWeight: onlyIf(gemInfo.caratWeight, gemData.caratWeight),
                dimensions: onlyIf(gemInfo.dimensions, gemData.dimensions),
                cut: onlyIf(gemInfo.cut, gemData.cut),
                setting: onlyIf(gemInfo.setting, gemData.setting),
                originCountry: onlyIf(gemInfo.origin, gemData.origin),
            }
            product.gemStones.push(gemStone)
        }
    
        // variants
    
        for(let j=0;j<variantMap.length;j++) {
            let variantData = variantMap[j]
            if(variantData.productId !== product.productId) {
                continue
            }
            let variant: IProductVariant = {
                variantId: variantData.variantId,
                available: variantData.status === 'enabled'
            }
            if(variantData.ringsize || variantData.ringSize) {
                variant.ringsize = variantData.ringsize || variantData.ringSize
            }
            if(variantData.material) {
                variant.material = variantData.material
            }
            product.variants.push(variant)
            if(variant.available) {
                product.available = true
            }
    
            // available variant aspects
    
            extractProductVariantAspects(product, variant)
        }
    
        products.push(product);
    }
    
    return products
}

export {
    extractProducts,
    extractProductVariantAspects,
    extractProductVariantAspectsAvailability,
    makeImages,
}